import React from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { LanguageProvider } from "./context/LanguageContext";
import Home from "./components/Home";
import Projects from "./components/Projects";
import Experience from "./components/Experience";
import Personal from "./components/Personal";
import ChatterboxPage from "./components/projects/chatterbox/ChatterboxPage";
import DhowPage from "./components/projects/dhow/DhowPage";
import ZkSnarkPage from "./components/projects/zksnark/ZkSnarkPage";
import WeensyOSPage from "./components/projects/WeensyOS/WeensyOSPage";
import BinaryStarSystemPage from "./components/projects/BinaryStarSystem/BinaryStarSystemPage";
import BlackDeathSimulationPage from "./components/projects/BlackDeathSimulation/BlackDeathSimulationPage";
import MusicClassificationPage from "./components/projects/MusicClassification/MusicClassificationPage";
import SketchingLeastSquaresPage from "./components/projects/SketchingLeastSquares/SketchingLeastSquaresPage";
import Evrald from "./components/projects/Evrald/Evrald";
import CryptoAgent from "./components/projects/CryptoAgent/CryptoAgent";
import KnewitPage from "./components/projects/Knewit/KnewitPage.jsx";
import ScrollReset from "./components/ScrollReset";

function App() {
  return (
    <LanguageProvider>
      <Router>
        <div className="App">
          <ScrollReset />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/experience" element={<Experience />} />
            <Route path="/projects/chatterbox" element={<ChatterboxPage />} />
            <Route path="/projects/dhow" element={<DhowPage />} />
            <Route path="/projects/zksnark" element={<ZkSnarkPage />} />
            <Route path="/projects/weensyos" element={<WeensyOSPage />} />
            <Route path="/projects/evrald" element={<Evrald />} />
            <Route path="/projects/knewit" element={<KnewitPage />} />
            <Route
              path="/projects/binarystar"
              element={<BinaryStarSystemPage />}
            />
            <Route
              path="/projects/blackdeath"
              element={<BlackDeathSimulationPage />}
            />
            <Route
              path="/projects/musicclassification"
              element={<MusicClassificationPage />}
            />
            <Route
              path="/projects/sketchinglsq"
              element={<SketchingLeastSquaresPage />}
            />
            <Route path="/projects/crypto-agent" element={<CryptoAgent />} />
            <Route
              path="/cv"
              element={
                <Navigate
                  to="/assets/CV/MarkChen.pdf"
                  target="_blank"
                  state={{ title: "Mark Chen - CV" }}
                />
              }
            />
            <Route path="/personal" element={<Personal />} />
          </Routes>
        </div>
      </Router>
    </LanguageProvider>
  );
}

export default App;
